import React from 'react';

// Types
import { IntegrationSources } from '../types';

// Components
import { WpModal, WpModalBody, WpModalHeader, WpModalFooter } from 'Wpds/components/modal';
import { WpButton } from 'Wpds/components/button';
import IntegrationsWrapper from 'Dashboard/components/IntegrationsWrapper/IntegrationsWrapper';

// Styles
import './HubspotSourceModal.scss';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  oauthRedirectUrl?: string;
};

const HubspotSourceModal = ({ isOpen, toggleIsOpen, oauthRedirectUrl }: Props) => {
  const baseClassName = 'HubspotSourceModal';
  return (
    <WpModal isOpen={isOpen} onToggle={toggleIsOpen} innerClassName={baseClassName} size="sm" dismissOnBackdrop={false}>
      <WpModalHeader>Hubspot</WpModalHeader>
      <WpModalBody>
        <p>Connect Hubspot to use this source in your update.</p>
        <IntegrationsWrapper filters={{ showOnly: [IntegrationSources.HUBSPOT] }} redirectUrl={oauthRedirectUrl} />
      </WpModalBody>
      <WpModalFooter>
        <WpButton onClick={toggleIsOpen}>Done</WpButton>
      </WpModalFooter>
    </WpModal>
  );
};

export default HubspotSourceModal;
